export default __webpack_public_path__ + "static/media/water.bd57b120.png";